;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"b3c041c3a447d867c0c9d3ba47f01b1de46a4469"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs'
import { Env } from '@share/enums/env.enum.ts'

Sentry.init({
	dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
	environment: process.env.NEXT_PUBLIC_ENV,
	tracesSampleRate: 0.1,
	keepPreviousData: true,
	enabled: process.env.NEXT_PUBLIC_ENV === Env.PRODUCTION || process.env.NEXT_PUBLIC_ENV === Env.STAGE,
})
